import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { DefinedColumns } from '@vindr/services/interfaces';
import { useTranslation } from 'react-i18next';
import { FetchColumn } from './FetchColumn';

interface InstitutionColumnProps<T> extends DefinedColumns<T> {
  keyValue?: 'id' | 'code';
}

const InstitutionColumn = <T,>(props?: InstitutionColumnProps<T>) => {
  const { t } = useTranslation('Vindoc');

  const {
    title = 'Institution',
    dataIndex = 'institution_id' as keyof T,
    width = 80,
    key = 'institution_id' as keyof T,
    sorter,
    ellipsis = true,
    keyValue = 'id',
    ...rest
  } = props || {};

  return {
    title: t(title),
    dataIndex,
    key,
    width,
    sorter,
    ellipsis,
    render: (id) => (
      <FetchColumn
        queryFn={useGetInstitutions}
        defaultParams={{ limit: 100, offset: 0 }}
        queryParams={keyValue === 'id' ? { ids: id } : { code: id }}
        renderItem={(x) => x.name}
        searchParams={keyValue === 'id' ? { id: id } : { code: id }}
      />
    ),
    ...rest,
  };
};

export default InstitutionColumn;
